import Marquee from "react-fast-marquee";

const ITEMS = [
  "BOT NET DETECTED · 192.168.x BLOCKED",
  "CLICK FARM · HANOI · AUTO-EXCLUDED",
  "PROXY TRAFFIC · M247 LTD · FLAGGED",
  "COMPETITOR IP · 14 REPEAT CLICKS · BLOCKED",
  "DATA CENTER · AWS · SCORE 98 · BLOCKED",
  "VPN EXIT NODE · DENIED",
  "HEADLESS BROWSER · SCORE 91 · BLOCKED",
  "GEO MISMATCH · FILTERED",
];

export const ThreatMarquee = () => {
  return (
    <div className="relative border-y border-white/8 bg-[#0B101A]/60 py-4 overflow-hidden">
      <Marquee gradient={false} speed={40} className="overflow-hidden">
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span key={i} className="mx-8 font-mono text-xs tracking-widest uppercase text-slate-500 flex items-center gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[#39FF14]" />
            {t}
          </span>
        ))}
      </Marquee>
    </div>
  );
};
